import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import type { AuthSessionResponse } from "@yagni/shared";
import { AuthView } from "./AuthView.js";
import { sanitizeClaimToken, sanitizeReturnTo } from "./AuthView.js";
import { ClaimTeamRoomImport } from "./ClaimTeamRoomImport.js";
import { Spinner } from "../ui/spinner.js";

export function AuthPage() {
  const [session, setSession] = useState<AuthSessionResponse | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    fetch("/api/auth/session")
      .then((res) => {
        if (res.ok) {
          return res.json().then((payload: AuthSessionResponse) => setSession(payload));
        }
      })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  const handleAuthenticated = useCallback((_session: AuthSessionResponse) => {
    setSession(_session);
  }, []);

  if (checking) {
    // workspace-shell here too, so the session-check beat is already on the
    // bone canvas and AuthView doesn't flash from paper to bone.
    return (
      <div className="workspace-shell h-full grid place-items-center text-sm text-text-tertiary">
        <Spinner />
      </div>
    );
  }

  const claimToken = sanitizeClaimToken(new URLSearchParams(window.location.search).get("claim"));
  if (session && claimToken) {
    return <ClaimTeamRoomImport session={session} claimToken={claimToken} />;
  }

  if (session) {
    const returnTo = sanitizeReturnTo(new URLSearchParams(window.location.search).get("returnTo"));
    return <Navigate to={returnTo ?? "/"} replace />;
  }

  return <AuthView onAuthenticated={handleAuthenticated} />;
}
